<template>
  <a
    class="banner"
    :class="bannerClass"
    :style="{ backgroundImage: `url(${moduleData.image})` }"
    :href="moduleData.link">
    <p class="banner-text">
      {{ moduleData.bannerText }}
    </p>

    <button class="button button-main banner-button">
      {{ moduleData.bannerButtonText }}
    </button>
  </a>
</template>

<script>
export default {
  name: 'BannerModuleImage',

  props: {
    bannerClass: {
      type: String,
      default: '',
    },

    moduleData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  padding: 40px;
  grid-row: 2 / 5;
  grid-column: span 1;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-size: cover;
  background-position: center;
  overflow: hidden;
}

.banner-two-cols {
  grid-column: span 2;
}

.banner-three-cols {
  grid-column: span 3;
}
.banner-text {
  color: $color--basic-white;
  max-width: 600px;
  padding-right: 60px;
  font-size: 48px;
  font-weight: 700;
  line-height: 48px;
  text-transform: uppercase;
  word-break: break-word;
}

.banner-button {
  text-transform: none;
  display: flex;
  width: fit-content;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  height: 48px;
  font-size: 15px;
}

@media screen and #{$screen-less-than-1024} {
  .banner-two-cols {
    grid-column: span 1;
  }
}

@media screen and #{$screen-less-than-768} {
  .banner {
    max-height: 220px;
    padding: 16px;
  }

  .banner-button {
    padding: 12px;
  }

  .banner-text {
    font-size: 24px;
    line-height: 30px;
    max-width: 80%;
    padding-right: unset;
  }
}

@media screen and #{$screen-less-than-480} {
  .banner {
    grid-row: 2 / 3;
  }

  .banner-text {
    font-size: 16px;
    line-height: 20px;
  }

  .banner-button {
    height: 40px;
  }
}
</style>
